// // plug.js
// import {$getClient} from './$httpClient';
// import {$getServer} from './$httpServer';




const plug = {  //  定义一个对象
  install (Vue, options) {  // 需要拥有一个 install 方法
    Vue.prototype.$msg = 'Hello I am test.js'
    // Vue.prototype.$get=async (url,params)=>{
    //   let res={};
    //     if(process.env.VUE_ENV === 'server'){
    //       res= await $getServer(url,params);
    //     }else{
    //       res=await $getClient(url,params);
    //     }
    //   return res;
    // }
  }
}
// 导出这个对象
export default plug



// WEBPACK FOOTER //
// ./src/plug/$http/$http.js